<template>
<div>
    <md-dialog :md-active="showDialog" class="customer-group-dialog-browse" @md-opened="setDefault" @md-closed="clearValue" :md-click-outside-to-close="false">
        <md-dialog-title>Browse Customer</md-dialog-title>

        <div class="layout-dialog">
            <div class="md-layout -search">
                <div class="customer">
                    <md-field md-inline md-clearable>
                        <md-input placeholder="Search Customers" v-model="keyword" @input="inputSearch"></md-input>
                    </md-field>
                </div>

                <div class="customer-area">
                    <md-field>
                        <label for="movie">Customer Area</label>
                        <md-select v-model="selectedCustomerArea" @md-selected="searchCustomerArea">
                            <md-option value="">Select Customer Area.</md-option>
                            <md-option :value="item.code" v-for="(item,idx1) in dataCustomerArea" :key="idx1">{{item.title}}</md-option>
                        </md-select>
                    </md-field>
                </div>

                <div class="customer-type">
                    <md-field>
                        <label for="movie">Customer Type</label>
                        <md-select v-model="selectedCustomerType" @md-selected="searchCustomerType" :disabled="selectedCustomerArea == ''?true:false">
                            <md-option value="">Select Customer Type.</md-option>
                            <md-option :value="item.code" v-for="(item,idx2) in dataCustomerType" :key="idx2">{{item.code}} : {{item.title}}</md-option>
                        </md-select>
                    </md-field>
                </div>

                <div class="price-type">
                    <md-field>
                        <label for="movie">Price Type</label>
                        <md-select v-model="selectedPriceType" @md-selected="searchPricetypeType" :disabled="selectedCustomerArea == ''?true:false">
                            <md-option value="">Select Price Type.</md-option>
                            <md-option :value="item.code" v-for="(item,idx3) in dataPriceType" :key="idx3">{{item.code}}</md-option>
                        </md-select>
                    </md-field>
                </div>

            </div>

            <div class="md-layout -tables">
                <div class="tb-left" style="width: 50%">
                    <div class="label-search" v-if="customerSearchList.length === 0">
                        <div class="-labelsearch">Search for customer using search or selecting <br> from dropdown</div>
                    </div>
                    <div class="result-search" v-if="customerSearchList.length > 0">
                        <div class="-labelsearch">Search Results ({{ customerSearchList.length.toLocaleString() }})</div>
                    </div>

                    <div class="md-layout-item" :class="{'is-waiting': loader}" style="overflow:auto;">
                        <div v-if="customerSearchList.length !== 0">
                            <div id="table-cg-browse">
                                <div id="divTableHead">
                                    <div style="width: 9%; padding-left: 5px;">
                                        <label class="checkbox-container">
                                            <input type="checkbox" v-model="checkAll" name="chk-all" @change="selectAll">
                                            <span class="-checkbox-primary"></span>
                                        </label>
                                    </div>
                                    <div style="width: 15%">Code</div>
                                    <div style="width: 60%">Title</div>
                                    <div style="width: 16%">Status</div>
                                </div>
                                <div id="divTableBody">
                                    <div :class="'row-bg-gray'" v-for="(item, bIndex) in customerSearchList" :key="bIndex">
                                        <div style="width: 9%; padding-left: 5px;">
                                            <label class="checkbox-container">
                                                <input type="checkbox" v-model="selectedCustomer" name="chk" :value="item.code"  @change="onSelectData(item.code,$event,item)">
                                                <span class="-checkbox-primary"></span>
                                            </label>
                                        </div>
                                        <div style="width: 15%">{{ item.code }}</div>
                                        <div style="width: 60%" class="nowrap-title" :title="item.title_th">{{ item.title_th }}</div>
                                        <div style="width: 16%">{{ item.status }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tb-right" style="width: 50%">
                    <div class="label-selected">
                        <div class="-labelselect">Selected for Import</div>
                        <div class="-labelnum">{{ dataImport.length.toLocaleString()  }} ITEMS SELECTED</div>
                    </div>

                    <div class="label-search" v-if="dataImport.length === 0">
                        <div class="-labelsearch">No customers selected for import <br> Please select items from search results</div>
                    </div>

                    <div v-if="dataImport.length > 0 && dataImport.length !== 0">
                        <div id="table-cg-browse-select">
                            <div id="divTableHead">
                                <div style="width: 9%; padding-left: 5px;"></div>
                                <div style="width: 15%">Code</div>
                                <div style="width: 60%">Title</div>
                                <div style="width: 16%">Status</div>
                            </div>
                            <div id="divTableBody">
                                <div :class="'row-bg-gray'" v-for="(item, bsIndex) in dataImport" :key="bsIndex">
                                    <div style="width: 9%; padding-left: 5px;">
                                        <i class="md-icon material-icons -delete" title="Delete" @click="removeItem(item.code)">delete</i>
                                    </div>
                                    <div style="width: 15%">{{ item.code }}</div>
                                    <div style="width: 60%" class="nowrap-title" :title="item.title_th">{{ item.title_th }}</div>
                                    <div style="width: 16%">{{ item.status }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <md-dialog-actions class="-action">
            <!-- <md-button class="-cancel" @click="showDialog = false">CANCEL</md-button> -->
            <md-button class="-cancel" @click="onCancelCustomer">CANCEL</md-button>
            <md-button class="md-primary -confirm" @click="onImportCustomer">IMPORT</md-button>
        </md-dialog-actions>
    </md-dialog>
</div>
</template>

<script>
import CipherService from "@/services/cipher";
import CustomerService from "@/services/customer";
import CustomerBpAreaService from "@/services/customer.bparea";
import CustomerBpTtypeService from "@/services/customer.bptype";
import PriceTypeService from "@/services/pricetype";

export default {
    name: "dialogCustomer",
    props: {
        import: {
            type: Array
        },
        showDialog: {
            type: Boolean
        }
    },
    data() {
        return {
            loader: false,
            // showDialog: false,
            search_customer: null,
            keyword: "",
            selected: [],
            groupsMode: [],
            groups: [],
            subgroups: [],
            subgroupsMode: "",
            cggroups: [],
            cggroupsMode: "",
            probrowse: [],
            productIm: [],
            customer_area: "",
            customer_type: "",
            customer_code: "",
            data_customer_area: [],
            data_customer_type: [],
            data_customer_code: [],
            customerSearchList: [],
            selectedCustomer: [],

            //selectedImport:[],

            dataImport: [],
            checkAll: false,

            selectedCustomerArea: "",
            dataCustomerArea: [],

            selectedCustomerType: "",
            dataCustomerType: [],

            selectedPriceType: "",
            dataPriceType: []

            //   selectedCustomerCode: null,
            //   dataCustomerCode: []
        };
    },
    created() {
        PriceTypeService.getAll().then(response=>{
            this.dataPriceType = response;
        });

        // CustomerBpAreaService.getAll().then(response => {
        //     this.dataCustomerArea = response;
        // });

        CustomerService.getLob().then(response => {
            this.dataCustomerType = response;
        });

        this.dataCustomerArea = [
            {
                'code': '1',
                'title': 'กรุงเทพฯ'
            },
            {
                'code': '2',
                'title': 'ต่างจังหวัด'
            }
        ]
    },
    methods: {
        inputSearch() {
            if (this.keyword) {
                if (this.keyword.length >= 4) this.searchOnTableResult();
                else this.customerSearchList = [];
            } else {
                this.keyword = "";

                this.customerSearchList = [];

                if (this.selectedCustomerArea != '') this.searchOnTableResult();
            }

        },
        // loadSelectCustomer(){
        //     CipherService.getCustomerCode().then((response)=>{
        //         this.dataCustomerCode = response;
        //     })
        // },
        clearValue() {
            // this.keyword = "";
            this.selectedCustomerArea = null;
            this.selectedCustomerType = null;
            this.selectedPriceType = null;
            this.customerSearchList = [];
        },
        setDefault() {
            // console.log('set default', this.import)
            this.checkAll = false;
            // this.keyword = '';
            // this.selectedCustomerArea = "";
            // this.selectedCustomerType = "";
            // this.selectedPriceType = "";
            this.customerSearchList = [];
            this.dataImport = [];
            // //   this.selectedCustomer = [];
            //   this.selectedCustomerArea = "";
            //   this.selectedCustomerType = "";

            //   if(this.dataImport.length = 0){
            this.selectedCustomer = [];
            //   }

            for (let i = 0; i < this.import.length; i++) {
                this.dataImport.push(this.import[i])
            }

            for (let i = 0; i < this.dataImport.length; i++) {
                this.selectedCustomer.push(this.dataImport[i].code);
            }

            //console.log(this.dataImport.length);
            // this.$forceUpdate();

        },
        searchCustomerArea() {
            console.log('search customer area')
            //console.log(this.selectedCustomerArea);
            if (this.selectedCustomerArea == "") {
                this.selectedCustomerType = "";
                this.selectedPriceType = "";
            }
            this.searchOnTableResult();
            // }
        },
        searchPricetypeType(){
            console.log('search price type')
            this.searchOnTableResult();
        },
        searchCustomerType() {
            console.log('search customer type')
            // if(this.selectedCustomerType != ""){
            this.searchOnTableResult();
            // }
        },
        // onClosedialog() {},
        searchOnTableResult() {

            // if(this.keyword.length < 4) return;
            // if(this.selectedCustomerArea == '') return;
            // console.log("key",this.keyword, "area",this.selectedCustomerArea, "Type",this.selectedCustomerType)

            if (this.keyword == "" && this.selectedCustomerArea == "" && this.selectedCustomerType == "" && this.selectedPriceType == "") {
                this.customerSearchList = [];
                this.loader = false;
                return;
            };

            this.loader = true;
            let prams = {
                'keyword': this.keyword,
                'customerArea': this.selectedCustomerArea,
                'customerType': this.selectedCustomerType,
                'priceType': this.selectedPriceType
            };

            CustomerService.searchCustomer(prams)
                .then(response => {
                    this.customerSearchList = response;
                    //console.log(response);
                    this.loader = false;
                })
                .catch(error => console.log(error));

        },
        // mdSelectedgroups() {},
        onImportCustomer() {
            this.customerSearchList = [];
            this.$emit("onImport", this.dataImport);

            // this.showDialog = false;
            //console.log(this.dataImport);
        },
        onCancelCustomer() {
            this.customerSearchList = [];
            this.$emit("onCancel", false);
            // this.showDialog = false;
        },
        clearSearch() {},
        // isExistImport(code){
        //     let index = this.dataImport.findIndex(item => item.code === code);
        //     if(index > -1) return true;
        //     else return false;

        // },
        checkDeleteCheckbox(code, object) {
            var del = true;
            for (var i = 0; i < object.length; i++) {
                if (object[i] == code) {
                    del = false;
                }
            }
            return del; // if return true delete
        },
        onSelectData(code, event, item) {

            //this.checkAll = true;

            let index = this.selectedCustomer.indexOf(code);

            if (index === -1) {


                let customer = null;
                
                let idx = this.dataImport.findIndex(item => item.code === code);
                if(idx != -1)
                    customer = this.dataImport[idx];

                this.dataImport.splice(
                    this.dataImport.findIndex(item => item.code === code),
                    1
                );

                this.$emit('onRemoveItem', customer);
            } else {
                this.dataImport.push(item);

                this.$emit('onAddItem', item);

            }
            // if(this.checkDeleteCheckbox(item.code, item)){
            //     //
            // }else{
            //     this.dataImport.push(item);
            // }
            // if(this.checkDeleteCheckbox(code, event)){ // add
            //     for(let i =0;i < this.productIm.length; i++){
            //         if(this.productIm[i].code == code) {
            //             this.productIm.splice(i,1);
            //         };
            //     }

            // }else{ // remove

            // }

            //   console.log(this.customerSearchList.length, event.length);

            //   if (this.customerSearchList.length == event.length) {
            //     this.checkAll = true;
            //   } else {
            //     this.checkAll = false;
            //   }

            // console.log("customer list",this.customerSearchList.length)
            // console.log("customer selectd",this.selectedCustomer.length)

            // if (this.customerSearchList.length == this.selectedCustomer.length) {
            //     this.checkAll = true;
            // }else{
            //     this.checkAll = false;
            // }
        },

        selectAll() {

            if (this.checkAll == true) {
   

                //>>>>>>>>>
                // let tmp_import = JSON.parse(JSON.stringify(this.dataImport));
                // let tmp_search = JSON.parse(JSON.stringify(this.customerSearchList));
                // //            let tmp_merge = Object.assign(tmp_import, tmp_search);
                // let tmp_merge = tmp_import.concat(tmp_search);
                // const result = Array.from(new Set(tmp_merge.map(s => s.code))).map(code => {
                //     return code;
                // });
                // this.selectedCustomer = result;
                // //~~~~~~~~~~~~~~~~~~~~~~~~~~~
                // const result_2 = Array.from(new Set(tmp_merge.map(s => s))).map(item => {
                //     return item;
                // });
                // this.dataImport = result_2;
                //<<<<<<<<<<<<<<<<<<<<<<<

                           for(let i = 0; i < this.customerSearchList.length; i++)
                           {
                               if(this.dataImport.findIndex(item => item.code == this.customerSearchList[i].code) == -1){
                                   this.selectedCustomer.push(this.customerSearchList[i].code)
                                   this.dataImport.push(this.customerSearchList[i])
                               }
                               // if(this.selectedCustomer.indexOf(code) == -1)
                               // {
                
                               // }
                
                           }
            } else {

                for (let i = 0; i < this.customerSearchList.length; i++) {
                    let code = this.customerSearchList[i].code
                    this.dataImport.splice(this.dataImport.findIndex(item => item.code === code), 1);
                    this.selectedCustomer.splice(this.selectedCustomer.indexOf(code), 1);
                }
            }

        },
        removeItem(code) {
            let customer = null;
            let idx = this.dataImport.findIndex(item => item.code === code);
            if(idx != -1)
                customer = this.dataImport[idx];

            // remove from data import
            this.dataImport.splice(
                this.dataImport.findIndex(item => item.code === code),
                1
            );


            this.selectedCustomer.splice(this.selectedCustomer.indexOf(code), 1);

            this.$emit('onRemoveItem', customer);


            // remove from selected
        },
        asyncFindCustomerArea() {

        },
        asyncFindCustomerType() {

        },
        asyncFindCustomerCode() {

        },
        selectCustomerCode(code) {
            //console.log(code);
            let index = this.selectedCustomer.indexOf(code);
            if (index === -1) {
                this.selectedCustomer.push(code);

                let idx = this.customerSearchList.findIndex(item => item.code === code);
                this.dataImport.push(this.customerSearchList[idx])

                this.selectedCustomerCode = null;

            }

        },
        clearValue() {
            this.selectedCustomerArea = "";
            this.selectedCustomerType = "";
        }
    }
};
</script>

<style lang="scss">
.customer-group-dialog-browse {
    z-index: 9;
    width: 70%;
    height: 80%;

    .md-dialog-container {
        width: 100%;

        .md-dialog-title {
            margin-bottom: 10px;
        }
    }

    .layout-dialog {
        height: 100%;
        margin: 0 18px 10px 25px;

        .md-layout {
            &.-search {
                width: 100%;

                div {
                    // padding-right: 20px;
                    margin-right: 25px;

                    &.customer,
                    &.customer-area,
                    &.customer-type,
                    &.price-type {
                        width: 22%;
                    }

                    .md-field {
                        margin: 0px;
                        // padding-top: 0px;
                        min-height: unset;

                        .md-button {
                            margin-top: 16px;

                            .md-ripple {
                                padding-right: 0px;
                                padding-left: 0px;

                                .md-button-content {
                                    margin-right: 0px;
                                }
                            }
                        }

                        .md-menu.md-select {
                            margin-right: 0px;
                        }
                    }
                }
            }

            &.-tables {
                // height: 100%;
                height: calc(80vmin - 185px);
                margin-top: 25px;

                .tb-left {
                    // height: 70%;
                    padding-right: 15px;

                    .label-search {
                        display: table;
                        width: 100%;
                        // height: 100%;
                        height: calc(80vmin - 185px);
                        
                        .-labelsearch {
                            display: table-cell;
                            vertical-align: middle;
                            text-align: center;
                            color: gray;
                            opacity: 0.5;
                            font-weight: bold;
                        }
                    }

                    .result-search {
                        width: 100%;
                        padding: 10px 2px 5px 5px;
                    }
                }

                .tb-right {
                    // height: 70%;
                    padding-right: 5px;
                    background: #f7f7f7;

                    .label-search {
                        display: table;
                        width: 100%;
                        // height: 100%;
                        height: calc(80vmin - 245px);
                        
                        .-labelsearch {
                            display: table-cell;
                            vertical-align: middle;
                            text-align: center;
                            color: gray;
                            opacity: 0.5;
                            font-weight: bold;
                        }
                    }

                    .label-selected {
                        width: 100%;
                        padding: 10px 2px 5px 10px;

                        .-labelselect {
                            position: fixed;
                        }

                        .-labelnum {
                            width: 100%;
                            text-align: right;
                            color: gray;
                            opacity: 0.5;
                            font-weight: bold;
                        }
                    }
                }

                #table-cg-browse,
                #table-cg-browse-select {
                    .checkbox-container {
                        display: block;
                        position: relative;
                        padding-left: 35px;
                        margin-bottom: 12px;
                        cursor: pointer;
                        font-size: 22px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }

                    /* Hide the browser's default checkbox */
                    .checkbox-container input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        height: 0;
                        width: 0;
                    }

                    /* Create a custom checkbox */
                    .-checkbox-primary {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 20px;
                        width: 20px;
                        background-color: #fff;
                        border: 2px solid #767676;
                    }

                    /* On mouse-over, add a grey background color */
                    .checkbox-container:hover input~.-checkbox-primary {
                        background-color: #ccc;
                    }

                    /* When the checkbox is checked, add a blue background */
                    .checkbox-container input:checked~.-checkbox-primary {
                        background-color: #3e51b5;
                        border-color: #3e51b5;
                    }

                    /* Create the -checkbox-primary/indicator (hidden when not checked) */
                    .-checkbox-primary:after {
                        content: "";
                        position: absolute;
                        display: none;
                    }

                    /* Show the -checkbox-primary when checked */
                    .checkbox-container input:checked~.-checkbox-primary:after {
                        display: block;
                    }

                    /* Style the -checkbox-primary/indicator */
                    .checkbox-container .-checkbox-primary:after {
                        left: 6px;
                        top: 1px;
                        width: 5px;
                        height: 13px;
                        border: solid white;
                        border-width: 0 2px 2px 0;
                        -webkit-transform: rotate(45deg);
                        -ms-transform: rotate(45deg);
                        transform: rotate(45deg);
                    }

                    #divTableHead {
                        width: 98.2%;
                        display: -webkit-inline-box;
                        font-size: 13px;
                        font-weight: bold;
                        margin-top: 10px;
                        margin-bottom: 10px;

                        div {
                            // border: 1px solid pink;
                            padding-left: 5px;
                            padding-right: 5px;

                            &.-text-right {
                                text-align: right;
                            }

                            &.-text-center {
                                text-align: center;
                            }
                        }
                    }

                    #divTableBody {
                        width: 100%;
                        height: calc(80vmin - 270px);
                        display: block;
                        overflow-y: scroll;
                        font-size: 13px;

                        >div {
                            width: 100%;
                            height: 30px;
                            display: -webkit-inline-box;
                            padding-top: 5px;
                            padding-bottom: 5px;

                            div {
                                // border: 1px solid pink;
                                padding-left: 5px;
                                padding-right: 5px;

                                &.-text-right {
                                    text-align: right;
                                }

                                &.-text-center {
                                    text-align: center;
                                }

                                &.nowrap-title {
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                
                                .-delete {
                                    color: gray;
                                    font-size: 19px !important;
                                    vertical-align: middle;
                                    text-align: center;
                                    cursor: pointer;
                                }
                            }
                        }

                        .row-bg-gray:hover {
                            background: rgba(236, 236, 235, 1);
                        }

                        &::-webkit-scrollbar {
                            height: 7px;
                            width: 8px;
                        }
                    }
                }
            }
        }
    }

    .-action {
        position: fixed;
        padding: 8px 20px 10px 24px;
        bottom: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 100%;

        .md-button {
            margin-right: 0px !important;
        }

        .md-ripple {
            width: 100%;
            margin: 0;
        }

        .-cancel {
            color: #727272 !important;
            margin-right: 10px;
        }
    }
}
</style>
